module.exports = __webpack_public_path__ + "static/media/cn.b69b6262.svg";